/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import { buttonAutoFocusRingFix } from '../../styles/focus';
import messages from './messages';
import { escTextStyles } from './styles';
export var CancelEscButton = function CancelEscButton(_ref) {
  var onCancel = _ref.onCancel,
    autoFocus = _ref.autoFocus;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return jsx(Button
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  , {
    css: buttonAutoFocusRingFix,
    autoFocus: autoFocus,
    testId: "cancel-esc-button",
    type: "button",
    onClick: onCancel
  }, formatMessage(messages.labelCancel), jsx("span", {
    css: escTextStyles
  }, formatMessage(messages.labelEsc)));
};